module.exports = __webpack_public_path__ + "static/media/Team 27 - IGNITE.a72cc098.gif";